var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MediaCapture } from "./MediaCapture";
var AudioCapture = /** @class */ (function () {
    function AudioCapture(dotNetRef, id, format) {
        this._dotNetRef = dotNetRef;
        this._id = id;
        this._format = format;
        this._recorder = new MediaCapture(format);
        this._recorder.onStopped = this.onStopped.bind(this);
    }
    AudioCapture.prototype.isSupported = function () {
        return this._recorder.isSupported();
    };
    AudioCapture.prototype.record = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.emptyPlayList();
                        return [4 /*yield*/, this._recorder.start()];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        });
    };
    AudioCapture.prototype.stop = function () {
        if (this._recorder.state == "recording") {
            this._recorder.stop();
        }
    };
    AudioCapture.prototype.onStopped = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var buffer, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = Uint8Array.bind;
                        return [4 /*yield*/, data.arrayBuffer()];
                    case 1:
                        buffer = new (_a.apply(Uint8Array, [void 0, _b.sent()]))();
                        return [4 /*yield*/, this._dotNetRef.invokeMethodAsync('OnAudioCaptured', buffer)];
                    case 2:
                        _b.sent();
                        this.generateAudioElement(buffer);
                        return [2 /*return*/];
                }
            });
        });
    };
    AudioCapture.prototype.generateAudioElement = function (buffer) {
        var playList = this.getPlayList();
        if (playList) {
            this.emptyPlayList();
            var audio = document.createElement("audio");
            audio.setAttribute("controls", "");
            playList.appendChild(audio);
            var data = new Blob([buffer.buffer], { type: this._format });
            var audioURL = window.URL.createObjectURL(data);
            audio.src = audioURL;
        }
    };
    AudioCapture.prototype.emptyPlayList = function () {
        var playList = this.getPlayList();
        if (playList)
            playList.replaceChildren();
    };
    AudioCapture.prototype.getPlayList = function () {
        var playList = document.querySelector("#".concat(this._id, ">.play-list"));
        return playList;
    };
    AudioCapture.create = function (dotNetRef, id, format) {
        return new AudioCapture(dotNetRef, id, format);
    };
    return AudioCapture;
}());
export { AudioCapture };
